import { MESSAGE_CODE, MESSAGE_FROM, MESSAGE_TYPE } from "../constants/Notifications";
import { BLOCKED_SETTING_TRANSFER, REFERENCES_TRANSFER, SM_QUEUE_SERVER, TYPE_TRANSFER } from "../constants/constants";
import { triggerNotifications } from "../Helpers/helperMessages";
import { Singleton } from "../Singletons/Singleton";

const language = new Singleton();
let titleTransfer = '';

const sendTransferRequest = (that, data) => {
  if (that.sharedData.getGeneralPermissions()[BLOCKED_SETTING_TRANSFER.ALL] === "0") {
    triggerNotifications(that, MESSAGE_CODE.ASSISTED_TRANSFER[10500], MESSAGE_TYPE.ERROR, MESSAGE_FROM.SDK);
    return;
  }

  if (that.sharedData.getGeneralPermissions()[BLOCKED_SETTING_TRANSFER.ASSISTED] === "0") {
    triggerNotifications(that, MESSAGE_CODE.ASSISTED_TRANSFER[10501], MESSAGE_TYPE.ERROR, MESSAGE_FROM.SDK);
    return;
  }
  that.sendToRabbit(SM_QUEUE_SERVER, data);
  const transferNotification = language.getText('CallControlGUICallTransferBlindXferProcess');
  titleTransfer = titleTransfer + ': ' || '';
  triggerNotifications(that, MESSAGE_CODE.BLIND_TRANSFER[10403], MESSAGE_TYPE.INFO, MESSAGE_FROM.CW,  titleTransfer + transferNotification);
};

export const makeSvrAssistedTransferCallToAgent = (that, ext) => {
  const data = {
    action: "assistedCallTransfer",
    username: that.sharedData.getUserData().Login,
    reference: REFERENCES_TRANSFER.DIAL,
    phoneNumber: ext,
    typeTransfer: TYPE_TRANSFER.AGENT,
  };
  titleTransfer = 'Assisted Transfer ' + language.getText('CallControlGUICallTransferagents');
  sendTransferRequest(that, data);
};

export const makeSvrAssistedTransferCallToInboundCamp = (that, inboundCamp) => {
  const data = {
    action: "assistedCallTransfer",
    username: that.sharedData.getUserData().Login,
    reference: REFERENCES_TRANSFER.DIAL,
    phoneNumber: inboundCamp,
    typeTransfer: TYPE_TRANSFER.INBOUND_CAMP,
  };
  titleTransfer = 'Assisted Transfer ' + language.getText('CallControlGUICallTransferACD');
  sendTransferRequest(that, data);
};

export const makeSvrAssistedTransferCallToDirectory = (that, dirNumber) => {
  const data = {
    action: "assistedCallTransfer",
    username: that.sharedData.getUserData().Login,
    reference: REFERENCES_TRANSFER.DIAL,
    phoneNumber: dirNumber,
    typeTransfer: TYPE_TRANSFER.DIRECTORY_OR_EXTERNAL_NUMBER,
  };
  titleTransfer = "Assisted Transfer " + language.getText('CallControlGUICallTransferagenda');
  sendTransferRequest(that, data);
};

export const makeSvrAssistedTransferCallToManualNumber = (that,manualNumber) => {
  const data = {
    action: "assistedCallTransfer",
    username: that.sharedData.getUserData().Login,
    reference: REFERENCES_TRANSFER.DIAL,
    phoneNumber: manualNumber,
    typeTransfer: TYPE_TRANSFER.DIRECTORY_OR_EXTERNAL_NUMBER,
  };
  titleTransfer = 'Assisted Transfer ' + language.getText('CallControlGUICallTransferphones');
  sendTransferRequest(that, data);
};

export const makeSvrAssistedTransferSwitchPrimaryCall = (that) => {

  if(!that.sharedData.getConnectedTransfer()){
    console.warn("Transfer not exists...");
    triggerNotifications(that, MESSAGE_CODE.ASSISTED_TRANSFER[10504], MESSAGE_TYPE.ERROR, MESSAGE_FROM.SDK);
    return;
  }
  if (that.sharedData.getMainCall()) {
    console.warn("Main call is connected");
    triggerNotifications(
      that, 
      MESSAGE_CODE.ASSISTED_TRANSFER[10505], 
      MESSAGE_TYPE.INFO, 
      MESSAGE_FROM.CW, 
      "Connected: " + language.getText('CallControlGUIAssistedCallTransfermainCall')
    );
    return;
  }

  that.sharedData.setMainCall(true);

  const data = {
    action: "assistedCallTransfer",
    username: that.sharedData.getUserData().Login,
    reference: REFERENCES_TRANSFER.SWTICH_MAIN_CALL,
    phoneNumber: "",
    callId: "",
    typeTransfer: TYPE_TRANSFER.SWTICH,
  };
  sendTransferRequest(that, data);
  
  let _that = that;
  setTimeout(() => {
    _that.svrEvents.onSecondCall({
      secondCall:false,
      message: "Switch to main call",
      success: true,
    });
  }, 250);

};

export const makeSvrAssistedTransferSwitchSecondaryCall = (that) => {
  if(!that.sharedData.getConnectedTransfer()){
    console.warn("Transfer not exists...");
    triggerNotifications(that, MESSAGE_CODE.ASSISTED_TRANSFER[10504], MESSAGE_TYPE.ERROR, MESSAGE_FROM.SDK);
    return;
  }
  if (!that.sharedData.getMainCall()) {
    console.warn("Secondary call is connected");
    triggerNotifications(
      that, 
      MESSAGE_CODE.ASSISTED_TRANSFER[10505], 
      MESSAGE_TYPE.INFO, 
      MESSAGE_FROM.CW, 
      "Connected: " + language.getText('CallControlGUIAssistedCallTransfersecondCall')
    );
    return;
  }
  const data = {
    action: "assistedCallTransfer",
    username: that.sharedData.getUserData().Login,
    reference: REFERENCES_TRANSFER.SWTICH_SECOND_CALL,
    phoneNumber: "",
    callId: "",
    typeTransfer: TYPE_TRANSFER.SWTICH,
  };
  sendTransferRequest(that, data);
};

export const makeSvrAssistedTransferCreateConference = (that) => {
  if(!that.sharedData.getConnectedTransfer()){
    console.warn("Transfer not exists...");
    triggerNotifications(that, MESSAGE_CODE.ASSISTED_TRANSFER[10504], MESSAGE_TYPE.ERROR, MESSAGE_FROM.SDK);
    return;
  }
  if (!that.sharedData.getMainCall()) {
    console.warn("To create the conference you need to be on the main call");
    triggerNotifications(that, MESSAGE_CODE.ASSISTED_TRANSFER[10506], MESSAGE_TYPE.WARN, MESSAGE_FROM.SDK);
    return;
  }
  const data = {
    action: "assistedCallTransfer",
    username: that.sharedData.getUserData().Login,
    reference: REFERENCES_TRANSFER.CREATE_CONFERENCE,
    phoneNumber: "",
    callId: "",
    typeTransfer: TYPE_TRANSFER.SWTICH,
  };
  titleTransfer = 'Assisted Transfer ' + language.getText('CallControlGUIAssistedCallTransferconference');
  sendTransferRequest(that, data);
  let _that = that;
  const messageEventConference = {
    success: true,
    message: "Conference call connected successfully",
  }
  setTimeout(() => {
    _that.svrEvents.onConferenceCallConnected(messageEventConference);
  }, 500);
};

export const makeSvrAssistedTransferCall = (that) => {
  
  if(!that.sharedData.getConnectedTransfer()){
    console.warn("Transfer not exists...");
    triggerNotifications(that, MESSAGE_CODE.ASSISTED_TRANSFER[10504], MESSAGE_TYPE.ERROR, MESSAGE_FROM.SDK);
    return;
  }
  if (!that.sharedData.getMainCall()) {
    console.warn("To transfer the call you need to be on the main call");
    triggerNotifications(that, MESSAGE_CODE.ASSISTED_TRANSFER[10507], MESSAGE_TYPE.WARN, MESSAGE_FROM.SDK);
    return;
  }
  const data = {
    action: "assistedCallTransfer",
    username: that.sharedData.getUserData().Login,
    reference: REFERENCES_TRANSFER.TRANSFER_CALL,
    phoneNumber: "",
    callId: "",
    typeTransfer: TYPE_TRANSFER.SWTICH,
  };
  sendTransferRequest(that, data);
};

export const handleSvrAssistedTransferLeaveConference = (that) => {
  if(!that.sharedData.getConnectedTransfer()){
    console.warn("Transfer not exists...");
    triggerNotifications(that, MESSAGE_CODE.ASSISTED_TRANSFER[10504], MESSAGE_TYPE.ERROR, MESSAGE_FROM.SDK);
    return;
  }
  if (!that.sharedData.getMainCall()) {
    console.warn("To leave the conference you need to be on the main call");
    triggerNotifications(that, MESSAGE_CODE.ASSISTED_TRANSFER[10508], MESSAGE_TYPE.ERROR, MESSAGE_FROM.SDK);
    return;
  }
  const data = {
    action: "assistedCallTransfer",
    username: that.sharedData.getUserData().Login,
    reference: REFERENCES_TRANSFER.LEAVE_CONFERENCE,
    phoneNumber: "",
    callId: "",
    typeTransfer: TYPE_TRANSFER.SWTICH,
  };
  sendTransferRequest(that, data);
};


export const handleSvrAssistedTransferHangupCall = (that) => {

  if(!that.sharedData.getConnectedTransfer()){
    console.warn("Transfer not exists...");
    triggerNotifications(that, MESSAGE_CODE.ASSISTED_TRANSFER[10504], MESSAGE_TYPE.ERROR, MESSAGE_FROM.SDK);
    return;
  }

  that.hangUp();
};

export const handleSvrAssistedTransferHangupSecondCall = (that) => {
  const data = {
    action: "assistedCallTransfer",
    username: that.sharedData.getUserData().Login,
    reference: REFERENCES_TRANSFER.HANGUP_SECOND_CALL,
    phoneNumber: "",
    callId: "",
    typeTransfer: TYPE_TRANSFER.SWTICH,
  };
  sendTransferRequest(that, data);
};

